import { gql } from "@apollo/client";

export default gql`
  mutation removePosition($data: RemovePositionInput!) {
    removePosition(data: $data)
  }
`;
